import { render, staticRenderFns } from "./NoRequestableLeaveTypesError.vue?vue&type=template&id=5d4c84b6"
import script from "./NoRequestableLeaveTypesError.vue?vue&type=script&lang=js"
export * from "./NoRequestableLeaveTypesError.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports